export default __webpack_public_path__ + "static/media/storyIQ-footer-icon.ca5d6954.svg";